import { render } from "./TfVerify.vue?vue&type=template&id=1152f56c"
import script from "./TfVerify.vue?vue&type=script&lang=js"
export * from "./TfVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__